import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { exposeEventToPartner } from '../../Helpers/events';

const Cookies = () => {
  const { isExternalPartnerForm } = useSelector((store) => store.formConfig);
  const { isFinalPageBeforeSubmission } = useSelector((i) => i.navigation);
  const { iFrameId } = useSelector((store) => store.optionalFormConfig);
  const [cookiesRequested, setCookiesRequested] = useState(false);

  useEffect(() => {
    if (
      !cookiesRequested &&
      !isExternalPartnerForm &&
      isFinalPageBeforeSubmission
    ) {
      exposeEventToPartner({
        eventType: 'cookiesRequested',
        eventObject: {
          iFrameId,
        },
      });
      setCookiesRequested(true);
    }
  }, [isFinalPageBeforeSubmission, isExternalPartnerForm]);

  return null;
};

export default Cookies;
